module.exports = __webpack_public_path__ + "img/news001.cad07701.png";